<!-- src/views/Layout.vue -->
<template>
  <el-container class="container">
    <!-- 头部组件 -->
    <Header></Header>

    <!-- 中部内容（路由出口） -->
    <el-main>
      <router-view />
      <!-- 子路由内容在此显示 --></el-main
    >

    <!-- 尾部组件 -->
    <Footer></Footer>
  </el-container>
</template>

<script setup>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
</script>
<!-- 写一个浏览前请求 -->
<!-- 显示请求结果的请求 -->

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
   max-width: 1440px;
  margin: 0 auto;
  width: 100%;
}
:root {
  --el-main-padding: 0 !important; /* 覆盖 20px */
}

/* 响应式设计 */
@media (max-width: 1440px) {
  .container {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0;
  }
}
</style>
